"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clsx = _interopRequireDefault(require("clsx"));

var _Icon = _interopRequireDefault(require("../Icon/Icon"));

var _excluded = ["imageUrl", "footerLabel", "galleryCount", "imageCover", "className", "alt"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
 * The Thumbnail component is used to embed a miniature version of a larger picture.
 */
var Thumbnail = function Thumbnail(_ref) {
  var imageUrl = _ref.imageUrl,
      footerLabel = _ref.footerLabel,
      galleryCount = _ref.galleryCount,
      imageCover = _ref.imageCover,
      className = _ref.className,
      alt = _ref.alt,
      attributes = _objectWithoutPropertiesLoose(_ref, _excluded);

  var classes = (0, _clsx.default)('uk-thumbnail', footerLabel ? 'uk-thumbnail--withLabel' : '', galleryCount ? 'uk-thumbnail--withGallery' : '', imageCover ? 'uk-thumbnail--cover' : '', className);
  return /*#__PURE__*/_react.default.createElement("div", _extends({
    className: classes
  }, attributes), imageUrl ? /*#__PURE__*/_react.default.createElement("img", {
    src: imageUrl,
    alt: alt
  }) : /*#__PURE__*/_react.default.createElement("svg", {
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M16 20a3.08 3.08 0 01-.53 0L19 16.47a3.08 3.08 0 010 .53 3 3 0 01-3 3z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M28 11v12a3 3 0 01-3 3H9.42l4.47-4.47a5 5 0 006.64-6.64l2.54-2.54A1 1 0 0024 13a1 1 0 001-1 1 1 0 00-.65-.93l2.46-2.46A3 3 0 0128 11zM27.71 4.29a1 1 0 00-1.42 0L22.59 8H14a2 2 0 00-2-2h-2a2 2 0 00-2 2H7a3 3 0 00-3 3v12a3 3 0 001.2 2.39l-.91.9a.21.21 0 00-.06.08l-.07.07a1 1 0 001.55 1.27l22-22a1 1 0 000-1.42zM16.54 14a3.28 3.28 0 00-.54 0 3 3 0 00-3 3 3.29 3.29 0 000 .54l-1.51 1.56A4.8 4.8 0 0111 17a5 5 0 015-5 4.8 4.8 0 012.1.49z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M19 17a3 3 0 01-3 3 3.08 3.08 0 01-.53 0L19 16.47a3.08 3.08 0 010 .53z"
  })), galleryCount > 0 && !footerLabel && /*#__PURE__*/_react.default.createElement("div", {
    className: "uk-thumbnail__footer"
  }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    name: "camera",
    className: "uk-thumbnail__icon"
  }), /*#__PURE__*/_react.default.createElement("span", null, "+\u2009", galleryCount)), footerLabel && /*#__PURE__*/_react.default.createElement("div", {
    className: "uk-thumbnail__footer"
  }, footerLabel));
};

Thumbnail.propTypes = {
  /**
   * Label that will apear at the bottom of the thumbnail
   */
  footerLabel: _propTypes.default.string,

  /**
   * Numbers of slides
   */
  galleryCount: _propTypes.default.number,

  /**
   * Link to image
   */
  imageUrl: _propTypes.default.string,

  /**
   * ImageCover option that behaves like background-image: cover;
   */
  imageCover: _propTypes.default.bool
};
var _default = Thumbnail;
exports.default = _default;